<template>
  <div class="item">
    <div class="pic-box">
      <img class="p1" src="../../../assets/img/value-p1.png">
      <div class="p2"></div>
    </div>
    <h1>应用价值探索</h1>
    <div class="con">
      <span>信贷质押</span><span class="margin-l">应用商店</span><br>
      <span>支付体系</span><span class="margin-l">更多场景</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "value-exploration"
  }
</script>

<style lang="less" scoped>
  @import "../../../assets/less/animate";

  .item {
    width: 25%;
    height: 100%;
    min-width: 290px;
    cursor: pointer;
    .pic-box {
      position: relative;
      margin: 82px auto 0;
      width: 172px;
      height: 130px;
      .p1 {
        position: absolute;
        left: calc(~'50% - 60px');
      }
      .p2 {
        width: 120px;
        height: 104px;
        position: absolute;
        left: calc(~'50% - 60px');
        top: 0;
        background: url("../../../assets/img/value-p2.png");
        background-size: 100% 100%;
      }
    }
    h1 {
      margin: 40px 0 25px;
      font-size: 2rem;
      text-align: center;
    }
    .con {
      font-size: 1.75rem;
      color: #999999;
      text-align: center;
      .margin-l {
        margin-left: 10px;
      }
    }
    &:hover {
      box-shadow: 0px 0px 40px rgba(111, 111, 111, 0.04);
    }
    &:hover .p2 {
      opacity: 0;
      background: url("../../../assets/img/value-p3.png");
      background-size: 100% 100%;
      animation: value-p2 2s linear infinite;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/part2/pics/ValueExploration.vue